import { render } from "./NavItem.vue?vue&type=template&id=3b158896&scoped=true&lang=pug"
const script = {}

import "./NavItem.vue?vue&type=style&index=0&id=3b158896&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3b158896"

export default script